import axios from "axios";
import { BACKEND_BASEURL } from "../../../db/baseUrl";
export const API_PURCHASE = `${BACKEND_BASEURL}api/purchases/`;

const createPurchase = async (purchaseData) => {
  const response = await axios.post(
    API_PURCHASE + "createPurchase",
    purchaseData
  );
  return response.data;
};
const addRemovePurchase = async ({ purchaseData, id }) => {
  const response = await axios.patch(
    `${API_PURCHASE}addRemovePurchase/${id}`,
    purchaseData
  );
  return response.data;
};

const updatePurchase = async ({ purchaseData, id }) => {
  const response = await axios.patch(
    `${API_PURCHASE}updatePurchase/${id}`,
    purchaseData
  );
  return response.data;
};
const deletePurchase = async (purchaseId) => {
  const response = await axios.delete(
    `${API_PURCHASE}deletePurchase/${purchaseId}`
  );
  return response.data;
};
const getPurchases = async () => {
  const response = await axios.get(API_PURCHASE + "getPurchases");
  return response.data;
};
const getPurchaseById = async (id) => {
  const response = await axios.get(`${API_PURCHASE}getPurchaseById/${id}`);
  return response.data;
};

const PurchaseServices = {
  createPurchase,
  getPurchases,
  addRemovePurchase,
  updatePurchase,
  deletePurchase,
  getPurchaseById,
};
export default PurchaseServices;
